<template>
	<MasterAwbdispatch-component>
		<div class="animated fadeIn">
		 <b-row>
            <b-col sm="12">
              <b-card>
            	<div slot="header">
                 <strong>MasterAwb Dispatch</strong>
			    </div>
				<b-row>
					<b-col cols="4">
						<b-form-group label="From Date : "  :label-cols="3" >
						<v-date-picker
							mode="single"
							input-class="dateInput"
							:available-dates="{ start: null, end: new Date() }"
							v-model="fromDate"
						>
						</v-date-picker>
						</b-form-group>
					</b-col>
					<b-col cols="4">
						<b-form-group label="To Date : "  :label-cols="3" >
						<v-date-picker
							mode="single"
							input-class="dateInput"
							:available-dates="{ start: null, end: new Date() }"
							v-model="toDate"
						>
						</v-date-picker>
						</b-form-group>
					</b-col>
					<b-col cols="2" style="text-align:left;">
						<b-form-group>
						<button class="btn btn-primary" @click="dispatchMasterawbListForKsa()"> Search </button>                       
						<button class="btn btn-danger ml-1" @click="refresh()"> <i class="fa fa-refresh"></i> </button>                       
						</b-form-group>
					</b-col>
				</b-row>
			    <b-col sm="12" class="text-right">
	               <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
                </b-col> 
			    <b-table 
				responsive show-empty  :busy="isBusy" :items="dispatchitem" :fields="dispatchfields"  :current-page="currentPage" :per-page="perPage" :filter="filter"   :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" :bordered="bordered" id="mytable">

                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
           		<template slot="shipment_count" slot-scope="row">
           			 <button title="View Shipment" @click="viewShipment(row.item.master_awb)" style="background-color:white !important;" class="btn btn-link"  >
                  <span style="color:#1b8eb7"> {{row.item.shipment_count}}</span>
               
               </button>
           		</template>

               </b-table>
                <b-col md="12" class="my-1 ">
	            <!-- <b-pagination
	                v-model="currentPage"
	                :total-rows="totalRows"
	                :per-page="perPage"
	                class="my-0"
	              ></b-pagination> -->
				  <b-pagination
						v-model="currentPage"
						:total-rows="rows"
						:per-page="perPage"
						aria-controls="mytable"
					></b-pagination>
          </b-col> 
            <b-modal size="lg" title="MasterAwb Shipment Log" v-model="shipmentModal" hide-footer>
          	<b-row>
              <b-col sm="12" class="text-right">
				<b-button v-if="total_row_shipment>0"  style="float: right;" @click="awbforkasdownloadCSV()"
					size="md" variant="primary">Download</b-button>
					<br><br>
               <p > <b>Total Records :<span style="color:red;">{{total_row_shipment }}</span></b> </p>
              </b-col> 
              <b-col sm="12">
	            <b-table responsive show-empty  :items="shipmentawblist" :busy="isBusyshipment"  :fields="fields1" :current-page="shipcurrentPage" :per-page="shipperPage" :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" id="shipmytable">
	            	<div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
	            </b-table>
	         </b-col>
	         <b-col md="12" class="my-1 " v-if="total_row_shipment>10">
            <!-- <b-pagination
                v-model="shipcurrentPage"
                :total-rows="total_row_shipment"
                :per-page="shipperPage"
                class="my-0"
              ></b-pagination> -->
			  <b-pagination
			  v-model="shipcurrentPage"
			  :total-rows="shiprows"
			  :per-page="shipperPage"
			  aria-controls="shipmytable"
		  ></b-pagination>
          </b-col> 
           </b-row>
           </b-modal>
              </b-card>
            </b-col>
         </b-row>
		</div>
	</MasterAwbdispatch-component>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
export default {
	data(){
		return{
			outlined:true,
	        bordered: true,
	        sortDesc: false,
	        allowCustomValue : true,
	        sortDirection: 'desc',
	        filter: null,
	        sortBy: null,
			isBusy:false,
			pageOptions: [5, 10, 15],
			currentPage:1,
			perPage:  10,
			dispatchitem:[],
	        dispatchfields:[
	        {key: 'deliveryagentname', label: 'Rider Name'},
	        {key: 'master_awb', label: 'Master AWB'},
		    {key: 'status', label: 'Status'},
		    {key: 'shipment_count', label: 'Shipment Count'},
		    {key: 'created_date', label: 'Dispatch Date'},
		    // {key: 'dispatch_date', label: 'Dispatch Date'},    
	        ],
	        totalRows:0,
	        shipmentModal:false,
	        shipmentawblist:[],
	        fields1:[
	          { key: 'shipmentId', label: 'Shipping Id', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'masterAwb', label: 'Master AWB', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	          { key: 'shipmentstatus', label: 'Shipment Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	           { key: 'deliverystatus', label: 'Delivery Status', sortable: true, sortDirection: 'desc',tdClass: 'nameOfTheClass' },
	       ],
            total_row_shipment:0,
            isBusyshipment:false,	
			shipcurrentPage:1,
			shipperPage:10,
			selectedmaterAWB : '',

			toDate:new Date(),
        	fromDate:new Date(),
		}
	},
	created(){
		this.dispatchMasterawbListForKsa();
	},
	computed: {
      rows() {
        return this.dispatchitem.length
      },
	  shiprows() {
        return this.shipmentawblist.length
      }
    },

	methods: {
		dispatchMasterawbListForKsa(){
		  var userdata = localStorage.getItem('userData')
	      var userInfo = JSON.parse(userdata)
	      this.isBusy = true;

		  if(this.fromDate > this.toDate){
			this.$fire({
				text: "From date must be smaller than To date",
				type: "warning",
				timer: 30000
			}); 
			this.isBusy = false;
			return
			}


	      const Obj_listing = {
	    		status:'Dispatch',
	            hub_id:`${userInfo.pickuplocationmasterid}`,
				from_date: this.fromDate ? this.formatDate(this.fromDate) : null,
            	to_date: this.toDate ? this.formatDate(this.toDate) : null,
	                }
	      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getStatusWiseMasterawbListForKsa`,Obj_listing)
	            .then((result) => {
	           
           
          this.isBusy = false;
          if (result.body.returnmsg =="Successful") {
                
             this.dispatchitem = result.body.returnvalue
                  
             this.totalRows = result.body.returnvalue.length;
 
              } 
              else {
                this.createditem=[];
                this.totalRows=0;  
              }
            })
            .catch((ex) => {
              console.log('error', ex)
            })
		},
		viewShipment(masterAwb){
			this.selectedmaterAWB = masterAwb;
			console.log("masterawbbbbbbbbbb",masterAwb)
			this.masterawbShipmentlist(masterAwb);
			// this.isBusyshipment=false;
			this.shipmentModal=true;

		},
		masterawbShipmentlist: function(masterAwb) {
		
		console.log("Master",masterAwb);
		var userdata = localStorage.getItem('userData')
		var userInfo = JSON.parse(userdata)
		this.isBusyshipment=true;
		var Obj = {
			
			master_awb:masterAwb,
		
		};  
		console.log("TYYY",Obj);
	

			this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistOfMasterawbForKsa`,Obj)
			.then((result) => {
			console.log(result);
			this.isBusyshipment=false;
			if (result.body.returnmsg === 'Successful') {
				
			this.shipmentawblist=result.body.returnvalue;
			this.total_row_shipment=result.body.returnvalue.length;
				
			} 
			else {
			this.shipmentawblist=[];
			this.total_row_shipment=0;
			}
			})
			.catch((ex) => {
			console.log('error-----', ex)
			})   
		},

		awbforkasdownloadCSV: function() {
            document.getElementById("overlay").style.display = "block";
            var userdata = localStorage.getItem("userData");
            var userInfo = JSON.parse(userdata);

            var csvObj = {
                sysusermasterid: `${userInfo.sysusermasterid}`,
                master_awb:this.selectedmaterAWB
            };
			console.log("ooooooooooooooooooo",csvObj)
            this.$http.post(`${CONSTANTS.MISREPORT_API_URL}/getShipmentlistReportOfMasterawbForKsa`,csvObj)
                .then((result) => {
                console.log(result.url);
                document.getElementById("overlay").style.display = "none";
                if (result.body == "success") {
                    // alert("Please Check Ur Mail For Downlod Link");
					this.$fire({
						text:"Please Check Your Mail For Downlod Link",
						type: "success",
						timer: 30000
					}); 
                } else {
                    // alert("Can not Download");
					this.$fire({
						text:"Can not Download",
						type: "error",
						timer: 30000
					}); 
                }
            });
        },

		refresh(){

			this.fromDate = new Date();
			this.toDate = new Date();
			this.createditem = [];
			this.totalRows = 0;
			this.dispatchMasterawbListForKsa();
			
			//this.getRiderRVPDayWiseListing(1);
      	},

		formatDate: function(date) {
			var d = new Date(date),
				month = "" + (d.getMonth() + 1),
				day = "" + d.getDate(),
				year = d.getFullYear();
			if (month.length < 2) month = "0" + month;
			if (day.length < 2) day = "0" + day;
			return [year, month, day].join("-");
			},
		}
	
	};
</script>